// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getFirestore } from "firebase/firestore"; // ✅ THIS LINE IS MISSING

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDqh9WLzsxs2zW_MthESqSkq9vbRcba6cg",
  authDomain: "juliustestimonials.firebaseapp.com",
  projectId: "juliustestimonials",
  storageBucket: "juliustestimonials.firebasestorage.app",
  messagingSenderId: "962008588179",
  appId: "1:962008588179:web:2658e3a6c9c74faeed9266"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
